import React from 'react';
import BannerImage from '../../images/500.png';
import './Banner1.css';

const Banner1 = () => {
  return (
    <div className="banner-container">
      <img src={BannerImage} alt="50% Off Banner" className="banner-image" />
        </div>
  );
}

export default Banner1;
